module.exports = __webpack_public_path__ + "img/light-f-fm-Path 51@3x.1135a1ce.png";